import { CgCustomDomainStatus } from '@provision/landing-page-utils';
import { useCgCustomDomains } from 'src/graphql/entities/cg-custom-domain/use-cg-custom-domain';
import { useClientGatewayUrl } from 'src/graphql/entities/client-gateway-url/use-client-gateway-url';

/** Where clients reach a segment's pages: its active custom domain, else the partner's Client Gateway address. */
export const useSegmentBaseUrl = (
  partnerId: number | null,
  brandId: string | undefined,
): string | undefined => {
  const gatewayUrl = useClientGatewayUrl(partnerId);
  const { domains } = useCgCustomDomains(partnerId);
  const hostname = domains.find(
    (domain) =>
      domain.status === CgCustomDomainStatus.Active &&
      brandId !== undefined &&
      domain.brandIds.includes(brandId),
  )?.hostname;

  return hostname ? `https://${hostname}` : (gatewayUrl ?? undefined);
};
